import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getAOBOGraphDataTimeline,
  getAOBOGraphDataValueQty,
  getAOBORange,
  getAOBOReport,
  getAOBOTableData,
  getBuyerCodeDetails,
  getCompCode,
  getPartDetails,
} from "../api/aobo";

export const fetchAOBORange = createAsyncThunk(
  "aobo/fetchAOBORange",
  async (params) =>
    getAOBORange(
      params?.orderType,
      params?.department,
      params?.compCode,
      params?.buyerList,
      params?.filterType
    )
);

export const fetchAOBOBuyerCodeDetails = createAsyncThunk(
  "aobo/fetchAOBOBuyerCodeDetails",
  async (params) =>
    getBuyerCodeDetails(
      params?.page,
      params?.limit,
      params?.department,
      params?.search
    )
);

export const fetchAOBOCompCode = createAsyncThunk(
  "aobo/fetchAOBOCompCode",
  async () => getCompCode()
);

export const fetchAOBOReport = createAsyncThunk(
  "aobo/fetchAOBOReport",
  async (params) =>
    getAOBOReport(
      params?.orderType,
      params?.department,
      params?.compCode,
      params?.buyerList,
      params?.filterType,
      params?.category,
      params?.dayRangeList,
      params?.rangeValue,
      params?.parts
    )
);

export const fetchAOBOGraphDataTimeline = createAsyncThunk(
  "aobo/fetchAOBOGraphDataTimeline",
  async (params) =>
    getAOBOGraphDataTimeline(
      params?.page,
      params?.limit,
      params?.aggr,
      params?.orderType,
      params?.department,
      params?.compCode,
      params?.buyerList,
      params?.dayRangeList,
      params?.category,
      params?.parts
    )
);

export const fetchAOBOGraphDataValueQty = createAsyncThunk(
  "aobo/fetchAOBOGraphDataValueQty",
  async (params) =>
    getAOBOGraphDataValueQty(
      params?.page,
      params?.limit,
      params?.aggr,
      params?.orderType,
      params?.department,
      params?.compCode,
      params?.buyerList,
      params?.filterType,
      params?.category,
      params?.rangeValue,
      params?.parts
    )
);

export const fetchAOBOTableData = createAsyncThunk(
  "aobo/fetchAOBOTableData",
  async (params) =>
    getAOBOTableData(
      params?.page,
      params?.limit,
      params?.orderType,
      params?.department,
      params?.compCode,
      params?.buyerList,
      params?.filterType,
      params?.category,
      params?.dayRangeList,
      params?.rangeValue,
      params?.parts
    )
);

export const fetchPartDetails = createAsyncThunk(
  "aobo/fetchPartDetails",
  async (params) =>
    getPartDetails(
      params?.department,
      params?.buyerList,
      params?.page,
      params?.search
    ).then((res) => res)
);

export const aoboSlice = createSlice({
  name: "aobo",
  initialState: {
    loading: false,
    aoboRangeDetails: null,
    aoboBuyerCodeDetails: null,
    aoboBuyerCodeDetailsLoading: false,
    aoboCompCodeDetails: null,
    aoboReport: null,
    aoboGraphDataTimelineDetails: null,
    aoboGraphDataValueQtyDetails: null,
    aoboTableDataDetails: null,
    aoboPartDetails: null,
    aoboPartDetailsLoading: false
  },
  reducers: {
    resetTableDetails: (state, { payload }) => {
      state.aoboTableDataDetails = null;
    },
    resetAoboGraphDataTimelineDetails: (state, { payload }) => {
      state.aoboGraphDataTimelineDetails = null;
    },
    resetAoboGraphDataValueQtyDetails: (state, { payload }) => {
      state.aoboGraphDataValueQtyDetails = null;
    },
  },
  extraReducers: {
    [fetchAOBORange.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [fetchAOBORange.fulfilled]: (state, { payload }) => {
      state.aoboRangeDetails = payload;
      state.loading = false;
    },
    [fetchAOBORange.rejected]: (state, { payload }) => {
      state.loading = false;
    },
    [fetchAOBOBuyerCodeDetails.pending]: (state, { payload }) => {
      state.aoboBuyerCodeDetailsLoading = true;
    },
    [fetchAOBOBuyerCodeDetails.fulfilled]: (state, { payload }) => {
      state.aoboBuyerCodeDetails = payload;
      state.aoboBuyerCodeDetailsLoading = false;
    },
    [fetchAOBOBuyerCodeDetails.rejected]: (state, { payload }) => {
      state.aoboBuyerCodeDetailsLoading = false;
    },
    [fetchAOBOCompCode.fulfilled]: (state, { payload }) => {
      state.aoboCompCodeDetails = payload;
    },
    [fetchAOBOReport.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [fetchAOBOReport.fulfilled]: (state, { payload }) => {
      state.aoboReport = payload;
      state.loading = false;
    },
    [fetchAOBOReport.rejected]: (state, { payload }) => {
      state.loading = false;
    },
    [fetchAOBOGraphDataTimeline.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [fetchAOBOGraphDataTimeline.fulfilled]: (state, { payload }) => {
      state.aoboGraphDataTimelineDetails = payload;
      state.loading = false;
    },
    [fetchAOBOGraphDataTimeline.rejected]: (state, { payload }) => {
      state.loading = false;
    },
    [fetchAOBOGraphDataValueQty.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [fetchAOBOGraphDataValueQty.fulfilled]: (state, { payload }) => {
      state.aoboGraphDataValueQtyDetails = payload;
      state.loading = false;
    },
    [fetchAOBOGraphDataValueQty.rejected]: (state, { payload }) => {
      state.loading = false;
    },
    [fetchAOBOTableData.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [fetchAOBOTableData.fulfilled]: (state, { payload }) => {
      state.aoboTableDataDetails = payload;
      state.loading = false;
    },
    [fetchAOBOTableData.rejected]: (state, { payload }) => {
      state.loading = false;
    },
    [fetchPartDetails.pending]: (state, { payload }) => {
      state.aoboPartDetailsLoading = true;
    },
    [fetchPartDetails.fulfilled]: (state, { payload }) => {
      state.aoboPartDetails = payload;
      state.aoboPartDetailsLoading = false;
    },
    [fetchPartDetails.rejected]: (state, { payload }) => {
      state.aoboPartDetailsLoading = false;
    },
  },
});

export default aoboSlice.reducer;
export const {
  resetTableDetails,
  resetAoboGraphDataTimelineDetails,
  resetAoboGraphDataValueQtyDetails,
} = aoboSlice.actions;
